import axios from 'axios';

import { Id, PagedParams, PagedResponse, getData } from '@feature/utils';

import { Publisher, PublisherRequest } from './PublisherTypes';

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<Publisher>>('/publishers/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<Publisher>(`/publishers/${id}`).then(getData);
}

export function findByTitle(title: string) {
  return axios
    .get<Publisher>(`/publishers/find`, {
      params: {
        title,
      },
    })
    .then(getData);
}

export function edit(id: Id, request: PublisherRequest) {
  return axios.put<Publisher>(`/publishers/${id}`, request).then(getData);
}

export function create(request: PublisherRequest) {
  return axios.post<Publisher>(`/publishers`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/publishers/${id}`).then(getData);
}
